export default "__VITE_ASSET__D0o1N$3O__"